import i18n from '@/lang'
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * 检验编码格式
 * @param {string} requireMsg 必填的提示信息
 * @param {*} min 最小长度，默认3
 * @param {*} max 最大长度
 */
export const validateCode = (requireMsg, min = 3, max) => (rule, value, callback) => {
  if (!value) {
    return callback(new Error(requireMsg))
  }
  if (!/^[A-Za-z0-9_-]+$/.test(value)) {
    return callback(new Error(i18n.t('permission.codeCheckRule')))
  }
  if ((value.length - min < 0) || (max && value.length - max > 0)) {
    let str = i18n.t('permission.length_rule', { min: min, max: max })
    if (min && max === undefined) {
      str = i18n.t('permission.checkMinCharacter', { min: min - 1 })
    }
    return callback(new Error(str))
  }
  callback()
}
